<template>
    <!-- <div class="column is-one-quarter is-hidden-mobile"> -->
    <div class="column is-one-quarter is-hidden-mobile is-hidden-tablet-only">
        <div class="content">
            <div class="columns">
                <!-- <div class="column"></div> -->
                <div class="column columns is-multiline" style="gap: 2.5rem; display: flex;">
                    <router-link :to="'/' + $i18n.locale + '/tinyhousetrailer'"
                        class="products-anchor column is-two-fifths">
                        <figure class="image columns is-vcentered is-128x128 image-wrapper light-blue" style="margin-left: 0;">
                            <p>{{ introTexts.firstProductTitle }}</p>
                            <img class="is-rounded" src="/images/tiny-house-trailers-2025/tiny-trailer-dot.jpg" />
                        </figure>
                    </router-link>
                    <router-link :to="'/' + $i18n.locale + '/boat'" class="products-anchor column is-two-fifths">
                        <figure class="image columns is-vcentered is-128x128 image-wrapper dark-blue" style="margin-left: 0;">
                            <p>{{ introTexts.secondProductTitle }}</p>
                            <img class="is-rounded" src="/images/csonakszallitok/boat-dot.jpg" />
                        </figure>
                    </router-link>
                    <router-link :to="'/' + $i18n.locale + '/goodtransport'"
                        class="products-anchor column is-two-fifths">
                        <figure class="image columns is-vcentered is-128x128 image-wrapper orange" style="margin-left: 0;">
                            <p>{{ introTexts.thirdProductTitle }}</p>
                            <img class="is-rounded" src="/images/aruszallitok/machine-transporter-dot.jpg" />
                        </figure>
                    </router-link>
                    <router-link :to="'/' + $i18n.locale + '/detachabletrailers'"
                        class="products-anchor column is-two-fifths">
                        <figure class="image columns is-vcentered is-128x128 image-wrapper light-blue" style="margin-left: 0;">
                            <p>{{ introTexts.fourthProductTitle }}</p>
                            <img class="is-rounded" src="/images/detachable-trailers-2025-copy/detachable-dot.jpg" />
                        </figure>
                    </router-link>
                    <router-link :to="'/' + $i18n.locale + '/containertrailers'"
                        class="products-anchor column is-two-fifths">
                        <figure class="image columns is-vcentered is-128x128 image-wrapper dark-blue" style="margin-left: 0;">
                            <p>{{ introTexts.fifthProductTitle }}</p>
                            <img class="is-rounded" src="/images/container-trailers-2025/container-trailer-dot.jpg" />
                        </figure>
                    </router-link>
                    <router-link :to="'/' + $i18n.locale + '/extraoptions'"
                        class="products-anchor column is-two-fifths">
                        <figure class="image columns is-vcentered is-128x128 image-wrapper orange"
                            style="margin-left: 0;">
                            <p>{{ introTexts.sixthProductTitle }}</p>
                            <img class="is-rounded" src="/images/extra-options-2025/Stabilizer triangle.jpg" />
                        </figure>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        introTexts() {
            return this.$t("homePage");
        },
    }
}



</script>

<style lang="scss" scoped>
.products-anchor:hover img, 
.products-anchor:hover .image-wrapper::after {
    
        transform-origin: center 58%;
        transition: 0.3s ease-out;
        transform: scale(1.02);

}

.products-anchor {
    img {
        transition: 0.3s ease-out;
    }

    .image {
        padding: 8% 0;
    }

    .image img {
        width: 128px;
        height: 128px;
    }
    
}

.image p {
    position: absolute;
    right: 0;
    left: 0;
    text-align: center;
    color: #fff;
    z-index: 35;
    transition: 0.3s ease-out;
    text-transform: uppercase;
    font-size: 0.7em;
    max-width: 80%;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
}

.image-wrapper {
    position: relative;
    display: inline-block;
    width: 128px;
    height: 128px;
  }

  .image-wrapper img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 9999999px;
  }

  .image-wrapper::after {
    transition: 0.3s ease-out;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .image-wrapper.orange::after {
    background: rgba(229, 106, 37, 0.8);

  }

  .image-wrapper.dark-blue::after {
    background: rgba(0, 50, 61, 0.8);

  }

  .image-wrapper.light-blue::after {
    background: rgba(30, 110, 122, 0.8);

  }
</style>